<template>
  <div class="a">
    <!-- 头部 -->
    <titled :num="2"></titled>
    <span class="apphome">
      <div class="box">
        <div class="top">
          <div class="left">
            <span class="left_name">
              <div class="name">时间段</div>
              <el-select v-model="value" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-button type="primary" style="margin-left:10px" @click="getList">查询</el-button>
            </span>
            <!-- <vchart style="height: 280px;width:100%;" ref='vchart'></vchart> -->
          </div>
          <div class="right">
            <vchart style="height: 600px;width:100%;" ref="vchart2"></vchart>
          </div>
        </div>
        <!-- <el-table :data="tableData" :header-cell-style="{color:'#4CA5FF',fontFamily:'MicrosoftYaHeiUI',fontSize:'16px',fontWeight:900,backgroundColor:'#fff'}" height="300px" style="width: 100%">
                <template slot="empty">
            <span class="noData">
              <img src="../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="date" sortable label="事件日期" width="180"/> 
          <el-table-column prop="name" label="严重性" width="180" /> 
          <el-table-column prop="address" label="视图复制成功" /> 
          <el-table-column prop="address" label="类别" /> 
          <el-table-column prop="address" label="事件名称" /> 
          <el-table-column prop="address" label="被确认" /> 
          <el-table-column prop="12" label="注释" /> 
        </el-table> -->
      </div>
    </span>
  </div>
</template>
<script>
  import titled from '@/components/module/titled/titled.vue';
  import vchart from '@/components/module/chart/vchart.vue'
  import {alarmStatistics} from "../../api/maintain";
  export default {
    components: {
      titled,
      vchart
    },
    data () {
      return {
        tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普 1518 弄'
        },{
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普 1517 弄'
        },{
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普 1519 弄'
        },{
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普1516 弄'
        }],
        dayOption: {
          legend: {
            icon: "rect",
            right: '5%',
            top: '6%',
            itemHeight: 10,
            itemWidth: 10,
            textStyle: {
              color: "inherit"
            }
          },
          grid: {
            // 距离 上右下左 的距离
            left: '5%',
            right: '5%',
            bottom: '8%',
            top: '22%',
            // 大小是否包含文本【类似于boxsizing】
            containLabel: true,
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            }
          },
          xAxis: {
            type: 'category',
            data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
          },
          yAxis: {
            name: '事件',
            nameTextStyle: {
              fontSize: 15,
              padding: [0,0,0,30],
              color: '#999',
              rich: {
                a: {
                  // 没有设置 `lineHeight`，则 `lineHeight` 为 56
                }
              }
            },
            axisLine: {
              show: true,
            },
            type: 'value'
          },
          series: [
            {
              name: '信息',
              data: [150,230,224,218,135,147,260],
              type: "bar",
            },
            // {
            //   name: '维护',
            //   data: [150, 230, 224, 218, 135, 147, 260],
            //   type: "bar",
            // },
            // {
            //   name: '失败',
            //   data: [150, 230, 224, 218, 135, 147, 260],
            //   type: "bar",
            // },
            // {
            //   name: '检查功能',
            //   data: [150, 230, 224, 218, 135, 147, 260],
            //   type: "bar",
            // },
            // {
            //   name: '不合规格',
            //   data: [150, 230, 224, 218, 135, 147, 260],
            //   type: "bar",
            // }
          ]
        },

        optioned: {
          tooltip: {
            trigger: 'item'
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['40%','70%'],
              itemStyle: {
                normal: {
                  color: function(colors) {
                    var colorList=[
                      '#64D776',
                      '#4CA5FF',
                      '#FF2F2F',
                      '#FF8540',
                      '#FFE500',
                      '#75bedc'
                    ];
                    return colorList[colors.dataIndex];
                  }
                },
              },


              data: [
                {value: 1048,name: '信息'},
                {value: 735,name: '维护'},
                {value: 580,name: '失败'},
                {value: 484,name: '检查功能'},
                {value: 300,name: '不合规格'}
              ]
            }
          ]
        },
        options: [{
          value: 'DAY',
          label: '日'
        },{
          value: 'MON',
          label: '月'
        },{
          value: 'YEAR',
          label: '年'
        }],
        value: 'DAY',
        nowDevice: {},//当前设备
        dayData: [],
        monthData: [],
        yearData: [],
      }
    },
    computed: {
      setDeviceItem () {
        return this.$store.cacheStore.state.setDevice
      },
    },
    watch: {
      setDeviceItem: function(val) {
        this.nowDevice=val
        this.getList()
      },

    },
    mounted () {
      for(let i=1;i<=31;i++) {
        if(i<=24) {
          this.dayData.push(i>9? i+':00':'0'+i+':00')
        }
        if(i<=12) {
          this.yearData.push(i+'月')
        }
        this.monthData.push(i+'号');
      }
      this.dayOption.xAxis.data=this.dayData;
      // this.$refs.vchart.setData(this.optioned, true);
      this.$refs.vchart2.setData(this.dayOption,true);
      // this.getList()
    },
    methods: {
      getList () {

        alarmStatistics({'dateType': this.value,'deviiceNo': this.nowDevice.deviceNo}).then(res => {

          if(res.code==200) {
            // this.tableData = res.data
            if(this.value=='DAY') {
              this.dayOption.xAxis.data=this.dayData;
            } else if(this.value=='MON') {
              this.dayOption.xAxis.data=this.monthData;
            } else if(this.value=='YEAR') {
              this.dayOption.xAxis.data=this.yearData;
            }
            this.handleData(res.data)

          }
        })
      },
      handleData (data) {
        // console.log("最新事件",res);
        this.dayOption.series=[]
        this.dayOption.series.push({
          name: "消息",
          data: [],
          type: 'bar'
        });
        for(let key in data) {
          //  console.log(key,data[key]);
          this.dayOption.series[0].data.push(data[key])
        }
        // console.log(this.dayOption);
        this.$refs.vchart2.setData(this.dayOption,true);
      },


    }
  };
</script>
<style lang="scss" scoped>
  .box .right {
    flex: 1;
  }

  .box .left {
    width: 450px;
  }

  .left_name {
    display: block;
    margin-left: 25px;
    margin-top: 20px;
  }

  .apphome .left .name {
    height: 30px;
    font-family: 'Microsoft YaHei';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 30px;
    color: #999;
    margin-bottom: 5px;
  }

  .apphome .box {
    height: calc(100vh - 140px);
    overflow: hidden;
    overflow-x: scroll;
    width: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
  }

  .apphome .box .top {
    // display: flex;
    margin-bottom: -25px;
  }

  .apphome {
    padding: 15px;
    overflow-x: scroll;
    display: flex;
    margin-top: 1rem;
  }
</style>